"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

exports.__esModule = true;
exports.useWindowWidth = exports.useHasMounted = void 0;

var _react = require("react");

var useHasMounted = function useHasMounted() {
  var _ref = (0, _react.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      hasMounted = _ref2[0],
      setHasMounted = _ref2[1];

  (0, _react.useEffect)(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
};

exports.useHasMounted = useHasMounted;

var useWindowWidth = function useWindowWidth() {
  var _ref3 = (0, _react.useState)(0),
      _ref4 = _slicedToArray(_ref3, 2),
      width = _ref4[0],
      setWidth = _ref4[1];

  (0, _react.useLayoutEffect)(function () {
    var updateWidth = function updateWidth() {
      return setWidth(typeof window !== "undefined" ? window.innerWidth : 0);
    };

    window.addEventListener('resize', updateWidth);
    updateWidth();
    return function () {
      return window.removeEventListener('resize', updateWidth);
    };
  }, []);
  return width;
};

exports.useWindowWidth = useWindowWidth;